/**
 * 서버 응답의 HTTP Date 헤더로 클라이언트-서버 시간 오차를 보정한다.
 * 컴퓨터의 날짜/시각 자체가 틀려도(타임존 문제가 아니라 시계 자체가 틀린 경우)
 * 마감시간 관련 계산(오늘 요일, 카운트다운, 시작일 최소값 등)이 실제 서버 기준
 * "지금"에 최대한 가깝게 동작하도록 하기 위한 보정용.
 *
 * 주의: 이건 UX 보정일 뿐이다. 개발자도구 등으로 API를 직접 호출하는 우회까지는
 * 막지 못하므로, 마감시간 규칙의 실제 검증은 서버가 자신의 시계로 해야 한다.
 */

let serverOffsetMs = 0;
let hasSynced = false;

/** axios 응답 인터셉터에서 매 응답마다 호출 — 시간이 지나며 계속 보정됨 */
export const updateServerTimeOffsetFromResponse = (response) => {
  try {
    const dateHeader = response?.headers?.date;
    if (!dateHeader) return;
    const serverMs = Date.parse(dateHeader);
    if (!Number.isFinite(serverMs)) return;
    serverOffsetMs = serverMs - Date.now();
    hasSynced = true;
  } catch (error) {
    // 헤더 파싱 실패해도 무시하고 보정 없이(클라이언트 시계 그대로) 동작
  }
};

/** 서버 기준으로 보정된 현재 epoch ms (아직 동기화 전이면 클라이언트 시계 그대로) */
export const getNowMs = () => Date.now() + serverOffsetMs;

/** 보정된 "지금"을 KST로 다룰 때 쓰는 Date (getUTCHours 등으로 KST 값을 바로 읽는 관용 표현) */
export const getKoreaNowDate = () => new Date(getNowMs() + 9 * 60 * 60 * 1000);

export const isServerTimeSynced = () => hasSynced;
